<div class="task-item">

  <sc-loading-spinner [isLoading]="requestRunning">
    <sc-padding>
      <sc-flex>
        <sc-icon iconClass="fa-shield-check fa-2x" *ngIf="task.type === 'CHECK'"></sc-icon>
        <sc-icon iconClass="fa-file fa-2x" *ngIf="task.type === 'DOCUMENT'"></sc-icon>
        <sc-icon iconClass="fa-camera fa-2x" *ngIf="task.type === 'PICTURE'"></sc-icon>
        <sc-icon iconClass="fa-images fa-2x" *ngIf="task.type === 'PICTURE_SERIES'"></sc-icon>
        <sc-icon iconClass="fa-message fa-2x" *ngIf="task.type === 'MESSAGE'"></sc-icon>
        <sc-content-spacer></sc-content-spacer>
        <sc-dictionary-label dictionaryKey="dd.TASK.{{task.taskId}}.name"></sc-dictionary-label>
        <sc-content-spacer grow></sc-content-spacer>
        <sc-action-icon iconClass="fa-question" (click)="showProcessingHint()"></sc-action-icon>
        <sc-content-spacer></sc-content-spacer>

        <sc-button dictionaryKey="tmc.task-position-details.action.complete-message" (click)="completeTask()"
          *ngIf="!task.done && task.type === 'MESSAGE'"></sc-button>
        <sc-button dictionaryKey="tmc.task-position-details.action.complete-check" (click)="completeTask()"
          *ngIf="!task.done && task.type === 'CHECK'"></sc-button>
        <ac-resource-upload usage="transport-task-image" (uploaded)="handleResourceUpload($event)"
          *ngIf="!task.done && task.type === 'PICTURE'" [metaData]="{ taskId: task.id }"></ac-resource-upload>

        <sc-button dictionaryKey="tmc.task-position-details.action.complete-document" (click)="completeDocument()"
          *ngIf="task.type === 'DOCUMENT'"></sc-button>

        <sc-button dictionaryKey="tmc.task-position-details.action.complete-picture-series"
          (click)="completePictureSeries()" *ngIf="task.type === 'PICTURE_SERIES'"></sc-button>

        <ng-container
          *ngIf="task.done && task.type !== 'MESSAGE' && task.type !== 'CHECK' && task.type !== 'PICTURE'">
          <sc-content-spacer></sc-content-spacer>
        </ng-container>

        <sc-icon iconClass="fa-check fa-2x" *ngIf="task.done"></sc-icon>

      </sc-flex>
    </sc-padding>
  </sc-loading-spinner>
</div>
